import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { ContextMenu } from 'primeng/contextmenu';
import { interval } from 'rxjs';
import { MasterscreenService } from '../../../masterscreen/services/masterscreen.service';
import { DashboardFilter } from '../../../shared/models/dashboardFilter.model';
import { BaseService } from '../../../shared/services/base.service';
import { ConstantsService } from '../../../shared/services/constants.service';
import { NotificationsService } from '../../../shared/services/notification.service';
import { FileUtility } from '../../../shared/utility/file.utility';
import { MasterRequest, PassRequestDashBoardFilter, PassRequestReportDetails, PassRequestStatusData } from '../../model/masterrequest.model';
import { PersononboardConstantsService } from '../../services/persononboard-constants.service';
import { PersononboardService } from '../../services/persononboard.service';

@Component({
  selector: 'ara-pass-requests-dashboard',
  templateUrl: './pass-requests-dashboard.component.html',
  styleUrls: ['./pass-requests-dashboard.component.css']
})
export class PassRequestsDashboardComponent implements OnInit {
  @ViewChild('cm') contextMenu: ContextMenu;
  routesFlag: { routeName: string, routeURL: string; isClickable: boolean; }[];
  tempRoutesFlag: { routeName: string, routeURL: string; isClickable: boolean; }[];
  reportRoutes: { routeName: string, routeURL: string; isClickable: boolean; }[];
  passRequestForData: MasterRequest;
  passRequestForDataResponse: MasterRequest[] = [];
  passRequestForFormData: Request;
  passRequestForDocument: Document;
  display: boolean = false;
  displayPrintableArea: boolean = false;
  hideFilter: boolean;
  hideSort: boolean;
  searchModified: boolean = false;
  passRequestStatusRequest: PassRequestStatusData;
  passRequestDashBoardFilterData: PassRequestDashBoardFilter;
  passRequestDashBoardFilter: PassRequestDashBoardFilter = new PassRequestDashBoardFilter();
  selectedStatus: any[] = [];
  isStatusNull: boolean;
  statusList: any[] = [];
  IsHasItBeenMadeCompliant: boolean = false;
  IsPassRequestReport: boolean = false;
  pageSize: number = 1;
  rowCount: number;
  itemPerPage: number = 50;
  searchText: string = '';
  passRequestFilter: DashboardFilter;
  loggedInUserJSON: any;
  isShowPassrequestReport: boolean = false;
  companyDetailsResponse: any[];
  companyList: any[] = [];
  locations: any[] = [];
  locationDetails: any[];
  selectedCompany: any[];
  selectedLocation: any[];
  selectedFromDate: Date = null;
  selectedToDate: Date = null;
  passRequestReportDashBoardFilterData: DashboardFilter;
  isExportToExcel: boolean = false;
  exportToExcelData: any;
  pobListData: any;
  showPagination: boolean = true;
  noRecordsMsg: string;
  columnList: any;
  jsonString: any;
  passRequestReportData: PassRequestReportDetails;
  selectedPassId: any;
  contextItems: MenuItem[] = [];
  unitList: any[];
  selectedUnit: number[] = [];
  alertType: string;
  successDetails: string;
  errorDetails: string;
  confirmMessage: string;
  row: HTMLElement;
  window = window;
  isPassRequestsChecked: boolean = true;
  checked: boolean;
  offlineRoutes: any;
  isOnline: boolean = false;
  complientValues: any[] = [];
  selectedComplients: boolean[] = [];
  passId: number;
  independentPermissions: any;
  passTypes: any[] = [];
  selectedPassType: number[] = [];
  disableExport: boolean = false;
  ResetOrDone : boolean = false;

  constructor(private pobServices: PersononboardService, private baseService: BaseService,
    private masterscreenService: MasterscreenService, private notificationsService: NotificationsService,
    private translate: TranslateService) {
    this.hideFilter = true;
    this.hideSort = true;
    this.passRequestStatusRequest = new PassRequestStatusData();
    this.passRequestDashBoardFilterData = new PassRequestDashBoardFilter();
    this.selectedCompany = [];
    this.selectedLocation = [];
    this.passRequestReportDashBoardFilterData = new DashboardFilter();
    this.passRequestReportData = new PassRequestReportDetails();
    this.searchText = '';
    this.complientValues.push({
      "label": "Yes",
      "value": true,
      "checked": true
    });
    this.complientValues.push({
      "label": "No",
      "value": false,
      "checked": true
    });
    this.selectedComplients.push(true);
    this.selectedComplients.push(false);
  }

  ngOnInit() {
    this.checkedOnlineStatus();
    if (navigator.onLine) {
      this.baseService.showRootLoader = true;
      const routes = JSON.stringify(PersononboardConstantsService.PersonOnBoardUrl.InnerRoutes);
      this.tempRoutesFlag = JSON.parse(routes);
      this.independentPermissions = JSON.parse(this.baseService.getItemFromSession('UserIndependentPermissions'));
      if (!this.independentPermissions.POB_Contractor_Add &&
        !this.independentPermissions.POB_Contractor_Add_Unit &&
        !this.independentPermissions.POB_Staff_Add &&
        !this.independentPermissions.POB_Staff_Add_Unit &&
        !this.independentPermissions.POB_Admin) {
        for (let index = 0; index < this.tempRoutesFlag.length; index++) {
          if (this.tempRoutesFlag[index].routeName === "New Pass") {
            this.tempRoutesFlag.splice(index, 1);
            break;
          }
        }
      }
      this.routesFlag = [...this.tempRoutesFlag];
      this.baseService.setItemInSession('offlineRoutes', JSON.stringify(this.routesFlag));
      this.reportRoutes = PersononboardConstantsService.PersonOnBoardUrl.ReportRoutes;
      this.contextItems = [
        {
          label: 'Open In New Tab',
          icon: 'fa-external-link-square',
          command: e => this.openPassRequest()
        }
      ];
      const loggedInUser = this.baseService.getItemFromSession('loggedInUser');
      this.loggedInUserJSON = JSON.parse(loggedInUser);
      this.passRequestFilter = new DashboardFilter();
      this.getPassRequestStatus();
    } else {
      const routes = JSON.stringify(PersononboardConstantsService.PersonOnBoardUrl.OfflineRoutes);
      this.routesFlag = JSON.parse(routes);
      this.baseService.setItemInSession('offlineSplicedRoutes', JSON.stringify(this.routesFlag));
      this.getOfflineData();
    }
    this.baseService.translatorListener.subscribe((data) => {
      this.translate.use(data);
    });

    this.passTypes.push({ label: 'Staff', value: 1 });
    this.passTypes.push({ label: 'Contractor', value: 2 });
    this.selectedPassType = [1, 2];
  }
  getOfflineData() {
    this.offlineRoutes = JSON.parse(this.baseService.getItemFromSession('offlineSplicedRoutes'));
    if (this.offlineRoutes !== null) {
      this.routesFlag = this.offlineRoutes;
    }
  }
  checkedOnlineStatus() {
    const repeatCheck = interval(1);
    repeatCheck.subscribe(val => {
      if (navigator.onLine) {
        this.isOnline = true;
      }
      else {
        this.isOnline = false;
      }
    });
  }
  getPassRequestStatus() {
    const apiRequest = {
      Model: this.passRequestStatusRequest
    };
    this.pobServices.getPassRequestStatus(apiRequest, this.callbackMethodForGetPassRequestStatus.bind(this));
  }
  callbackMethodForGetPassRequestStatus(response) {
    if (response.Success) {
      response.Result.forEach(element => {
        if (this.independentPermissions.SUPER_Admin) {
          this.statusList.push(
            {
              label: element.Name,
              value: element.PassRequestStatusId,
              checked: true
            }
          );
          this.selectedStatus.push(element.PassRequestStatusId);
        } else {
          if (element.Name !== 'Deleted') {
            this.statusList.push(
              {
                label: element.Name,
                value: element.PassRequestStatusId,
                checked: true
              }
            );
            this.selectedStatus.push(element.PassRequestStatusId);
          }
        }
      });
    }
    this.getUnits();
  }

  getPOBResponse() {
    this.baseService.showRootLoader = true;
    if (!this.rowCount) {
      this.rowCount = this.itemPerPage * 2;
    }
    if (!this.selectedStatus.length) {
      this.statusList.forEach(element => {
        this.selectedStatus.push(element.value);
      });
    }
    this.passRequestDashBoardFilterData.PassRequestStatusId = this.selectedStatus;
    this.passRequestDashBoardFilterData.IsPassRequestReport = this.IsPassRequestReport;
    this.passRequestDashBoardFilterData.IsHasItBeenMadeCompliant = this.selectedComplients;
    this.passRequestDashBoardFilterData.PassType = this.selectedPassType;
    if (!this.selectedUnit.length) {
      this.unitList.forEach(element => {
        this.selectedUnit.push(element.value);
      });
    }
    this.passRequestDashBoardFilterData.Units = this.selectedUnit;
    if (!this.selectedLocation.length) {
      this.locations.forEach(element => {
        this.selectedLocation.push(element.value);
      });
    }
    if (!this.selectedComplients.length) {
      this.selectedComplients.push(true);
      this.selectedComplients.push(false);
    }
    this.passRequestDashBoardFilterData.Locations = this.selectedLocation;
    this.passRequestDashBoardFilterData.PassRequestFromDate = this.selectedFromDate !== null ? new Date(this.selectedFromDate.setHours(0, 0, 0)) : null;
    this.passRequestDashBoardFilterData.PassRequestToDate = this.selectedToDate !== null ? new Date(this.selectedToDate.setHours(23, 59, 59)) : null;
    if (!this.passRequestDashBoardFilterData.PageIndex) {
      this.passRequestDashBoardFilterData.PageIndex = 0;
    }
    if(this.ResetOrDone)
    {
      this.pageSize = 1;
      this.passRequestDashBoardFilterData.PageIndex = 0;
    }
    this.passRequestDashBoardFilterData.UserId = this.loggedInUserJSON.UserId;
    this.passRequestDashBoardFilterData.PageSize = this.itemPerPage;
    this.passRequestDashBoardFilterData.CurrentPage = !this.pageSize ? 1 : this.pageSize;
    this.passRequestDashBoardFilterData.SearchText = this.searchText;
    if (!this.passRequestDashBoardFilterData.OrderdByColoumName) {
      this.passRequestDashBoardFilterData.OrderdByColoumName = PersononboardConstantsService.ColumnConstants.POBId;
    }
    if (!this.passRequestDashBoardFilterData.OrderdBy) {
      this.passRequestDashBoardFilterData.OrderdBy = PersononboardConstantsService.ColumnConstants.DESC;
    }
    this.passRequestDashBoardFilterData.IsPassRequestReport = this.IsPassRequestReport;
    if (this.passRequestDashBoardFilterData.IsPassRequestReport) {
      this.getPassRequestReport();
    }
    this.passRequestDashBoardFilterData.SelectAll = this.isPassRequestsChecked;
    const filter = JSON.parse(this.baseService.getFilterData('pobFilter'));
    if (!this.searchModified && filter) {
      this.passRequestDashBoardFilterData = filter;
      this.selectedStatus = filter.PassRequestStatusId;
      this.IsPassRequestReport = filter.IsPassRequestReport;
      this.selectedPassType = filter.PassType;
      if (this.IsPassRequestReport) {
        this.getPassRequestReport();
      }
      this.selectedPassType = this.passRequestDashBoardFilterData.PassType;
      this.selectedComplients = this.passRequestDashBoardFilterData.IsHasItBeenMadeCompliant;
      this.selectedUnit = this.passRequestDashBoardFilterData.Units;
      this.selectedLocation = this.passRequestDashBoardFilterData.Locations;
      this.searchText = filter.SearchText;
      this.selectedFromDate = filter.PassRequestFromDate === null ? filter.PassRequestFromDate : new Date(filter.PassRequestFromDate);
      this.selectedToDate = filter.PassRequestToDate === null ? filter.PassRequestToDate : new Date(filter.PassRequestToDate);
      this.pageSize = this.passRequestDashBoardFilterData.CurrentPage;
      this.pobServices.setcurrentPersonOnBoardPageIndex(this.pageSize);
      this.selectedPassType = this.passRequestDashBoardFilterData.PassType;
      if (this.pageSize === 0) {
        this.passRequestDashBoardFilterData.PageIndex = 0;
      } else {
        this.passRequestDashBoardFilterData.PageIndex = ((this.pageSize * this.itemPerPage) - this.itemPerPage);
        this.rowCount = ((this.pageSize + 1) * this.itemPerPage);
      }
      this.isPassRequestsChecked = filter.SelectAll;
      if (!this.pobServices.getAllPassRequests()) {
        this.isPassRequestsChecked = true;
        this.passRequestDashBoardFilterData.SelectAll = true;
      }
    } else {
      this.baseService.setFilterData('pobFilter', JSON.stringify(this.passRequestDashBoardFilterData));
    }
    this.passRequestDashBoardFilterData.UserId = this.loggedInUserJSON.UserId;
    if (this.passRequestDashBoardFilterData) {
      const apiRequest = {
        Model: this.passRequestDashBoardFilterData
      };
      this.pobServices.getPOBResponseDetails(apiRequest, this.callbackMethodForGetPOBResponse.bind(this));
    }
    this.ResetOrDone = false;
  }
  /**
   * Callback method of get location details and save data into variable.
   * @param response - response of request.
   */
  callbackMethodForGetPOBResponse(response) {
    if (response.Success) {
       //BOC Pritesh
      //  if(response.Result.length > 0)
      //  {
      //  response.Result.forEach((element,index) => {
      //    if(element.PassStatus ==='Draft' && element.CreatedBy !== this.loggedInUserJSON.UserId)  
      //    {
      //      response.Result.splice(index,1);
      //    }
      //  });
      //  }
        //EOC Pritesh
      this.passRequestForDataResponse = response.Result;
      if (this.passRequestDashBoardFilterData.SelectAll && !this.searchModified) {
        this.selectAllPassRequests(this.passRequestDashBoardFilterData.SelectAll);
      } else if (this.searchModified) {
        this.passRequestDashBoardFilterData.SelectAll = true;
        this.pobServices.setAllPassRequests([]);
        this.selectAllPassRequests(this.passRequestDashBoardFilterData.SelectAll);
      } else {
        if (this.pobServices.getAllPassRequests()) {
          this.passRequestForDataResponse.forEach(element => {
            this.pobServices.getAllPassRequests().forEach(stored => {
              if (element.PassRequestId === stored) {
                element.Checked = true;
              }
            });
          });
        }
      }
      if (!response.Result || response.Result.length < this.itemPerPage) {
        this.rowCount = this.rowCount - this.itemPerPage;
      }
      if (response.Success) {
        if (response.Result.length === 0) {
          this.showPagination = false;
          this.noRecordsMsg = 'No Records Found!';
        } else {
          this.showPagination = true;
        }
      }
    }
    this.baseService.showRootLoader = false;
  }

  callbackMethodForGetPassRequestId(response) {
    if (response.Success) {
      this.passRequestForFormData = response.Result;
    }
  }

  onClickedOutside() {
    this.hideFilter = false;
    if (this.hideFilter == false && this.searchModified == true) {
      this.hideFilter = this.searchModified;
      this.searchModified = false;
    }
    this.hideSort = false;
  }
  onTabOpen() {
    this.hideFilter = true;
    this.hideSort = true;
  }

  searchData() {
    this.ResetOrDone = true;
    if (this.rowCount === 50) {
      this.rowCount = this.rowCount * 2;
    }
    if(this.searchText != "")
    {
      this.rowCount = 100;
    }
    this.searchModified = true;
    if (this.searchText !== this.passRequestDashBoardFilterData.SearchText) {
      this.getPOBResponse();
      this.pobServices.setAllPassRequests([]);
    }
  }

  clearSearch() {
    this.ResetOrDone = true;
    if (this.rowCount === 50) {
      this.rowCount = this.rowCount * 2;
    }
    this.searchText = '';
    this.searchModified = true;
    if (this.searchText !== this.passRequestDashBoardFilterData.SearchText) {
      this.getPOBResponse();
      this.pobServices.setAllPassRequests([]);
    }
  }

  // call when apply all filter
  doneFilter() {
    this.ResetOrDone = true;
    if (this.rowCount === 50) {
      this.rowCount = this.rowCount * 2;
    }
    this.searchModified = true;
    this.getPOBResponse();
    this.pobServices.setAllPassRequests([]);
    this.hideFilter = false;
  }
  // reset all value
  resetValue() {
    this.ResetOrDone = true;
    if (this.rowCount === 50) {
      this.rowCount = this.rowCount * 2;
    }
    this.selectedStatus = [];
    this.pageSize = 1;
    this.IsHasItBeenMadeCompliant = true;
    this.searchText = '';
    this.selectedCompany = [];
    this.selectedFromDate = null;
    this.selectedToDate = null;
    this.selectedUnit = [];
    this.selectedLocation = [];
    this.searchModified = true;
    this.selectedComplients = [];
    this.selectedComplients.push(true);
    this.selectedComplients.push(false);
    this.selectedPassType = [1, 2];
    this.getPOBResponse();
    this.pobServices.setAllPassRequests([]);
    this.onClickedOutside();
  }

  // Call when next page call
  getServerData(event) {
    this.pobServices.setcurrentPersonOnBoardPageIndex(event);
    if (event === 1) {
      this.passRequestDashBoardFilterData.PageIndex = 0;
    } else {
      this.passRequestDashBoardFilterData.PageIndex = ((event * this.itemPerPage) - this.itemPerPage);
      this.rowCount = ((event + 1) * this.itemPerPage);
    }
    this.pageSize = event;
    this.searchModified = true;
    this.getPOBResponse();
  }
  getLocation() {
    this.masterscreenService.getLocationDetails(null, this.callbackMethodForGetLocationDetails.bind(this));
  }
  callbackMethodForGetLocationDetails(response) {
    if (response) {
      this.locations = [];
      this.selectedLocation = [];
      this.locationDetails = response;
      this.locationDetails.forEach((location) => {
        this.locations.push(
          {
            'label': location.LocationName,
            'value': location.LocationId,
            'checked': true
          }
        );
        this.selectedLocation.push(location.LocationId);
      });
    }
    this.getPOBResponse();
  }
  getPassRequestReport() {
    const apiRequest = {};
    this.pobServices.getPassRequestReportDetails(apiRequest, this.callbackMethodForGetPassRequestReport.bind(this));
  }
  callbackMethodForGetPassRequestReport(response) {
    if (response.Success) {
      this.isShowPassrequestReport = true;
      this.passRequestReportData = response.Result;
    }
  }
  exportToExcel(value) {
    this.disableExport = true;
    this.notificationsService.toastNotify('info', 'Information Message', 'Downloading is in progress!');
    const filter = JSON.parse(this.baseService.getFilterData('pobFilter'));
    filter.SourceIds = [];
    this.pobServices.getAllPassRequests().forEach(element => {
      filter.SourceIds.push(element);
    });
    const apiRequest = {
      Model: filter
    }
    this.pobServices.getExportToExcelPassRequests(apiRequest, this.callbackMethodForGetExportToExcelPassRequests.bind(this));
  }
  showContextMenu(passRequest) {
    this.selectedPassId = passRequest.PassRequestId;
  }
  openPassRequest() {
    window.open('/pob/view-pass-request/' + this.selectedPassId, '_blank')
    this.contextMenu.hide();
  }
  getUnits() {
    const apiRequestUnit = {
      Model: {
        ModuleId: 0,
        UserId: this.loggedInUserJSON.UserId,
        IsActive : 0
      }
    }
    this.masterscreenService.getUnits(apiRequestUnit, this.callbackMethodForUnitDetails.bind(this));
  }
  callbackMethodForUnitDetails(response) {
    if (response.Success) {
      const unitDetails = response.Result;
      this.unitList = [];
      this.selectedUnit = [];
      unitDetails.forEach((unit) => {
        this.unitList.push(
          {
            'label': unit.UnitName,
            'value': unit.UnitId,
            'checked': true
          }
        );
        this.selectedUnit.push(unit.UnitId);
      });
    }
    this.getLocation();
  }
  showRequestReport(event) {
    if (event.target.checked) {
      this.IsPassRequestReport = true;
    } else {
      this.IsPassRequestReport = false;
      this.isShowPassrequestReport = false;
    }
    this.searchModified = true;
    this.getPOBResponse();
  }
  onYesClickedForConfirmation() { }
  onNoClickedForConfirmation() { }
  onOkClicked() { }
  selectPassRequests(passRequest, event) {
    let passRequests = this.pobServices.getAllPassRequests();
    if (event.target.checked) {
      passRequests.push(passRequest.PassRequestId);
      if (passRequests.length === this.passRequestForDataResponse.length) {
        this.isPassRequestsChecked = true;
      }
    } else {
      this.isPassRequestsChecked = false;
      this.passRequestDashBoardFilterData.SelectAll = this.isPassRequestsChecked;
      for (let index = 0; index < passRequests.length; index++) {
        const element = passRequests[index];
        if (passRequest.PassRequestId === element) {
          passRequests.splice(index, 1);
          break;
        }
      }
    }
    this.pobServices.setAllPassRequests(passRequests);
    this.baseService.setFilterData('pobFilter', JSON.stringify(this.passRequestDashBoardFilterData));
  }
  downloadZIP() {
    this.disableExport = true;
    this.notificationsService.toastNotify('info', 'Information Message', 'Downloading is in progress!');
    const passRequestIds = [];
    this.pobServices.getAllPassRequests().forEach(element => {
      passRequestIds.push({
        ProcessName: 'Incident',
        SourceId: element,
        UserId: this.loggedInUserJSON.UserId
      });
    });
    if (passRequestIds.length > 0) {
      const apiRequest = {
        Model: {
          SourceIds: passRequestIds
        }
      }
      this.pobServices.downloadZIP(apiRequest, this.callbackMethodForDownloadZIP.bind(this));
    }
  }
  callbackMethodForDownloadZIP(response) {
    if (response) {
      //Here assign the Byte array returned from API to data variable
      var fileDownLoadName = "zip_pass_requests.zip"; //Here we can assign name of the document
      FileUtility.downloadPDF(response, fileDownLoadName);
    }
    else{
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something Went Wrong."
      );
    }
    this.disableExport = false;
  }
  selectAllPassRequests(checked) {
    let selectedPassRequests = [];
    this.passRequestForDataResponse.forEach(element => {
      if (checked) {
        element.Checked = true;
        selectedPassRequests = this.pobServices.getAllPassRequests();
        if (!selectedPassRequests) {
          selectedPassRequests = [];
        }
        selectedPassRequests.push(element.PassRequestId);
        this.pobServices.setAllPassRequests(selectedPassRequests);
      } else {
        element.Checked = false;
        this.pobServices.setAllPassRequests([]);
      }
    });
    this.passRequestDashBoardFilterData.SelectAll = this.isPassRequestsChecked;
    this.baseService.setFilterData('pobFilter', JSON.stringify(this.passRequestDashBoardFilterData));
  }
  highlightCurrentSelectedObservation(id) {
    var el = document.getElementById(id);
    while (!this.checked && el !== null) {
      this.checked = true;
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      let currentColor = document.getElementById(id).style.backgroundColor;
      if (currentColor !== null && currentColor !== 'darkgray') {
        document.getElementById(id).style.backgroundColor = 'darkgray';
      }
      el = null;
    }
  }
  getCurrentDOMElementId(id) {
    this.pobServices.setcurrentPersonOnBoardRequestId(id);
    let passRequests = this.pobServices.getAllPassRequests();
    if (!passRequests.filter(element => {
      if (element === id) {
        return element;
      }
    })) {
      this.passRequestForDataResponse.forEach(element => {
        if (element.PassRequestId === id) {
          passRequests.push(element.PassRequestId);
          return;
        }
      });
      this.pobServices.setAllPassRequests(passRequests);
    }

  }
  ngAfterViewChecked() {
    let currentPassRequestId = this.pobServices.getcurrentPersonOnBoardRequestId();
    if (currentPassRequestId) {
      this.highlightCurrentSelectedObservation(currentPassRequestId);
    }
  }
  callbackMethodForGetExportToExcelPassRequests(response) {
    if(response.Success){
      this.exportToExcelData = response.Result;
      this.columnList = [
        { key: "PassId", value: "Pass ID" },
        { key: "FullName", value: "Full Name" },
        { key: "ApprovalStatus", value: "Approval Status" },
        { key: "DocumentStatus", value: "Document Status" },
        { key: "PassStatus", value: "Pass Status" },
        { key: "PassRequestToDate", value: "Expiry Date" },
        { key: "PassTypeName", value: "Pass Type" },
        { key: "CompanyName", value: "Company Name" },
        { key: "ContractHolder", value: "ContractHolder" },
        { key: "ContractNumber", value: "Contract Number" }
        // { key: "IsHasItBeenMadeCompliant", value: "Has it been made compliant" },
        // { key: "IsMarkedAsNonConformance", value: "Marked as Non-Conformance" }
      ];
      const parsedResponse: any = FileUtility.convertToCSV(this.exportToExcelData, this.columnList);
      FileUtility.downloadCSV(parsedResponse, 'PobRequestList.csv');
    }
    else{
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something Went Wrong."
      );
    }
    this.disableExport = false;
  }
  ascPassId() {
    this.passRequestDashBoardFilterData.OrderdBy = PersononboardConstantsService.ColumnConstants.ASC;
    this.passRequestDashBoardFilterData.OrderdByColoumName = PersononboardConstantsService.ColumnConstants.PassId;
    this.searchModified = true;
    this.getPOBResponse();
  }
  descPassId() {
    this.passRequestDashBoardFilterData.OrderdBy = PersononboardConstantsService.ColumnConstants.DESC;
    this.passRequestDashBoardFilterData.OrderdByColoumName = PersononboardConstantsService.ColumnConstants.PassId;
    this.searchModified = true;
    this.getPOBResponse();
  }
  ascExpiryDate() {
    this.passRequestDashBoardFilterData.OrderdBy = PersononboardConstantsService.ColumnConstants.ASC;
    this.passRequestDashBoardFilterData.OrderdByColoumName = PersononboardConstantsService.ColumnConstants.ExpiryDate;
    this.searchModified = true;
    this.getPOBResponse();
  }
  descExpiryDate() {
    this.passRequestDashBoardFilterData.OrderdBy = PersononboardConstantsService.ColumnConstants.DESC;
    this.passRequestDashBoardFilterData.OrderdByColoumName = PersononboardConstantsService.ColumnConstants.ExpiryDate;
    this.searchModified = true;
    this.getPOBResponse();
  }

  ascSubmissionDate() {
    this.passRequestDashBoardFilterData.OrderdBy = PersononboardConstantsService.ColumnConstants.ASC;
    this.passRequestDashBoardFilterData.OrderdByColoumName = PersononboardConstantsService.ColumnConstants.CreatedDate;
    this.searchModified = true;
    this.getPOBResponse();
  }

  descSubmissionDate() {
    this.passRequestDashBoardFilterData.OrderdBy = PersononboardConstantsService.ColumnConstants.DESC;
    this.passRequestDashBoardFilterData.OrderdByColoumName = PersononboardConstantsService.ColumnConstants.CreatedDate;
    this.searchModified = true;
    this.getPOBResponse();
  }

  downloadPDF(PassRequestId) {
    this.notificationsService.toastNotify('info', 'Information Message', 'Download is in Progress!');
    const apiRequest = {
      Model: {
        ProcessName: "POB",
        SourceId: PassRequestId,
      }
    };
    this.pobServices.downloadPDF(apiRequest, this.callbackMethodForDownloadPDF.bind(this));
  }
  callbackMethodForDownloadPDF(response) {
    if (response) {
      //Here assign the Byte array returned from API to data variable
      var fileDownLoadName = "pdf_pass.pdf"; //Here we can assign name of the document
      FileUtility.downloadPDF(response, fileDownLoadName);

    }
  }

  deletePass(passId: number): void {
    this.alertType = ConstantsService.Confirm;
    this.confirmMessage = "Do you want to delete this Pass?";
    this.passId = passId;
  }

  getOutput(output) {
    if (output) {
      this.ngOnInit();
    } else {
      this.notificationsService.toastNotify('error', 'Error Message', 'Record is in use!');
    }
  }
}
